export const Feedback = (props : any) => <svg {...props} width = "20" height = "20" viewBox = "0 0 20 20" fill = "none" xmlns = "http://www.w3.org/2000/svg" >
<g clipPath="url(#clip0_107_1800)">
<path d="M10.0001 6.66666V10M10.0001 13.3333H10.0084M18.3334 10C18.3334 14.6024 14.6025 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6024 1.66675 10C1.66675 5.39762 5.39771 1.66666 10.0001 1.66666C14.6025 1.66666 18.3334 5.39762 18.3334 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</g>
<defs>
<clipPath id="clip0_107_1800">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg >
